var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-state"},[_c('el-alert',{attrs:{"title":_vm.title,"type":_vm.type,"closable":false,"description":_vm.description,"show-icon":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }